export { default } from './BlockAwardsSlider'
